<template>
  <div>
    <div v-if="loading" class="loading-mask">
      Loading...
    </div>

    <PageHeader title="新卒面接集計" class="">
      <template #title-header-content>
        <div class="flex justify-end ml-auto">
          <div>
            <div class="text-xs font-bold text-white">メインタスク作成日</div>
            <div class="flex">
              <!-- 開始日 -->
              <WmsDateInput
                name="start"
                v-model="filter.start"
                class=""
              />

              <div class="font-bold text-white mx-2 self-center">～</div>

              <!-- 終了日 -->
              <WmsDateInput
                name="end"
                v-model="filter.end"
                class=""
              />
            </div>
          </div>

          <PrimaryButton text="検索" @click="getData()" class="mx-3 self-end"></PrimaryButton>

          <PrimaryButton class="bg-green-100 text-green-700 mr-2 self-end" text="面接一覧" @click="openList()">
            <Icon iconName="ViewGrid" slot="before" class="h-4 w-4" />
          </PrimaryButton>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-20 w-screen bottom-4 -mt-2">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 ---overflow-auto">

          <div class="w-full">
            <template>
            <div class="flex justify-center py-10">
              <div v-if="pieData&&Object.keys(pieData).length" class="mx-2">
                <!-- 応募数の男女比率 -->
                <div class="text-center font-bold">応募数の男女比</div>
                <PieChart :chartData="pieData" />
              </div>
              <div v-else class="text-gray-400 font-bold">
                対象データがありません。
              </div>

              <div v-if="lineData&&Object.keys(lineData).length" class="mx-2">
                <div class="text-center font-bold mb-2">月ごとの応募数・採用数（年月はメインタスク作成日）</div>
                <LineChart :chartData="lineData" />
                <div class="text-center font-bold">※採用数は辞退を除いた数字です</div>
              </div>

            </div>
            </template>

            <div v-if="list&&list.length" class="w-fit mx-auto mt-10">
              <div class="text-purple-400 font-bold">辞退</div>
              <table class="my-3">
                <thead class="">
                  <tr class="border border-gray-200">
                    <th v-for="(c, i) in columns" :key="'c'+i" scope="col" class="p-3 text-xs font-medium text-gray-500 tracking-wider bg-colu" :class="c.class">
                      {{ c.title }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(row, i) in list" :key="'row'+i" class="border border-gray-200 tracking-wider">

                    <!-- 年月 -->
                    <td class="p-3 whitespace-nowrap text-sm font-medium text-gray-500 text-center border-r">
                      {{ row.month }}
                    </td>

                    <!-- 辞退数 -->
                    <td class="p-3 whitespace-nowrap text-sm font-medium text-gray-700 text-center border-r">
                      {{ row.num }} 人
                    </td>

                    <!-- 理由 -->
                    <td class="p-3 whitespace-pre-line text-xs text-gray-700">
                      <div v-if="row.text&&row.text.length">●{{ row.text.join('\n●') }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
              <div v-else class="text-gray-400 font-bold w-fit mx-auto my-10">
                期間内の辞退者はいません。
              </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
import PieChart from '../components/PieChart.vue'
import LineChart from '../components/LineChart.vue'
import * as interviewsListManager from '@managers/interviewsListManager'
import * as moment from 'moment'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    Icon,
    PrimaryButton,
    WmsDateInput,
    PageHeader,
    PieChart,
    LineChart
  },

  data() {
    return {
      loading: false,
      filter: {
        start: moment().subtract(4, 'months').startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      },
      // 円グラフ
      pieData: null,
      // 折れ線グラフ
      lineData: null,
      // 辞退
      columns: [
        { title: '年月' },
        { title: '辞退数' },
        { title: '理由' },
      ],
      list: []
    }
  },

  watch: {
  },

  computed: {
  },

  created() {
    this.getData()
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      this.loading = true

      // 過去の集計結果を取得
      const res = await interviewsListManager.getNewGradList(this, this.filter)
      if (res) {
        this.pieData = res.pieData
        this.lineData = res.lineData
        this.list = res.decline

      } else {
        this.pieData = null
        this.lineData = null
        this.list = []
      }
      this.loading = false
    },
    
    /**
     *  一覧表示
     */
    openList() {
      const route = this.$router.resolve({
        name: 'InterviewsList'
      })

      window.open(route.href, '_blank')
    },
  }
}
</script>

<style scoped>
.bg-colu {
  background: #ebf0fb;
}

</style>